interface CardSkeletonProps {
  count?: number;
}

export function CardSkeleton({ count = 8 }: CardSkeletonProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          <div className="w-full aspect-[2/3] bg-background-200 animate-pulse"></div>
          <div className="p-4 space-y-2">
            <div className="h-4 w-3/4 rounded bg-background-200 animate-pulse"></div>
            <div className="h-3 w-1/2 rounded bg-background-200 animate-pulse"></div>
            <div className="h-3 w-full rounded bg-background-200 animate-pulse"></div>
          </div>
        </div>
      ))}
    </div>
  );
}